export function localizedExperience(exp, lang) {
  const useSpanish = lang === 'es';
  return {
    ...exp,
    role: useSpanish && exp.roleEs ? exp.roleEs : exp.role,
    date: useSpanish && exp.dateEs ? exp.dateEs : exp.date,
    description: useSpanish && exp.descriptionEs ? exp.descriptionEs : exp.description,
  };
}

export function localizedProject(project, lang) {
  const useSpanish = lang === 'es';
  return {
    ...project,
    name: useSpanish && project.nameEs ? project.nameEs : project.name,
    description: useSpanish && project.descriptionEs ? project.descriptionEs : project.description,
  };
}

export function pickSiteContent(siteContent, key, lang, fallback = '') {
  const row = siteContent?.[key];
  if (!row) return fallback;
  const value = lang === 'es' && row.es ? row.es : row.en;
  return value || fallback;
}
